import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { SharedModule }                        from '../shared/shared.module';
import { TableModule }                         from '../table/table.module';
import { VehicleVisualsActionsComponent }      from './vehicle-visuals.actions.component';
import { VehicleVisualsCatalogComponent }      from './vehicle-visuals.catalog.component';
import { VehicleVisualsCatalogModalComponent } from './vehicle-visuals.catalog-modal.component';
import { VehicleVisualsEmailComponent }        from './vehicle-visuals.email.component';
import { VehicleVisualsPlayerComponent }       from './vehicle-visuals.player.component';
import { VehicleVisualsService }               from './vehicle-visuals.service';
import { VehicleVisualsSettingsComponent }     from './vehicle-visuals.settings.component';
import { VehicleVisualsStates }                from './vehicle-visuals.states';

@NgModule({
  declarations: [
    VehicleVisualsActionsComponent,
    VehicleVisualsCatalogComponent,
    VehicleVisualsCatalogModalComponent,
    VehicleVisualsEmailComponent,
    VehicleVisualsPlayerComponent,
    VehicleVisualsSettingsComponent
  ],
  entryComponents: [
    VehicleVisualsActionsComponent,
    VehicleVisualsCatalogComponent,
    VehicleVisualsCatalogModalComponent,
    VehicleVisualsEmailComponent,
    VehicleVisualsPlayerComponent,
    VehicleVisualsSettingsComponent
  ],
  imports: [
    SharedModule,
    TableModule,

    UIRouterUpgradeModule.forChild({ states: VehicleVisualsStates })
  ],
  providers: [
    VehicleVisualsService
  ]
})
export class VehicleVisualsModule {}
